/**
 * 描述：租户管理--租户服务项信息
 * 日期：2017-12-13
 * 作者：liu_jinming
 */
'use strict';
angular.module("servicesTenantInfoModule", ['tManageMentServiceModule', 'checkNameRepeatedModule'])
    .controller("servicesTenantInfoCtrl", ["$scope", "$q", "$filter", "tManageMentService", "modalDialog", "trsHttpService",
        function($scope, $q, $filter, tManageMentService, modalDialog, trsHttpService) {
            initStatus();
            initData();
            /** [initData description] 初始化数据 */
            function initData() {
                getneedInfo().then(function(id) {
                    requestAllService(id);
                    $scope.tenantId = id;
                });
            }
            /** [initStatus description]初始化状态 */
            function initStatus() {
                $scope.data = {
                    serviceList: []
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 40,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 0
                };
            }
            /** [getneedInfo description]获取租户的租户id */
            function getneedInfo() {
                var deffer = $q.defer();
                var params = {
                    "serviceid": "mlf_tenant",
                    "methodName": "findTenantById"
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    deffer.resolve(data.TENANTID);
                });
                return deffer.promise;
            }
            /** [requestAllService description]请求所有问题 */
            function requestAllService(id) {
                var params = {
                    serviceid: 'mlf_tenant',
                    methodName: 'queryUsedServiceConfig',
                    CURRPAGE: $scope.page.CURRPAGE,
                    PAGESIZE: $scope.page.PAGESIZE,
                    TENANTID: id
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.serviceList = data.DATA;
                    $scope.page = data.PAGER;
                    for (var i in $scope.data.serviceList) {
                        var obj = $scope.data.serviceList[i];
                        if (!!obj.STARTTIME && !!obj.ENDTIME) {
                            obj.validityTime = obj.STARTTIME.slice(0, 10) + ' 至 ' + obj.ENDTIME.slice(0, 10);
                        }
                    }
                });
            }
            /** [requestData description]分页请求数据 */
            $scope.requestData = function() {
                requestAllService($scope.tenantId);
            };
        }
    ]);